import * as React from 'react';
import { IArticleListItem } from '../shared/shared-types';

export interface IArticleListItemProps {
    item: IArticleListItem
}


export class ArticleListItem extends React.Component<IArticleListItemProps, {}>{
    render() {
        return (
            <a className="article-list-item" href={this.props.item.url}>
                <h3 className="article-list-item-title" dangerouslySetInnerHTML={{ __html: this.props.item.title }}></h3>
                <p className="article-list-item-type">{this.props.item.mediaType}</p>
            </a>               
        );
    }
}


// WEBPACK FOOTER //
// ./~/source-map-loader!./app/src/shared/article-list-item.tsx